"use client";
import React, { useState } from 'react';
import styles from './index.module.scss';
import TextInput from "@/app/_components/Shared/TextInput";

const GratuityCalculator = () => {
    const [basicSalary, setBasicSalary] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [gratuity, setGratuity] = useState(null);

    const calculateGratuity = () => {
        const dailyWage = parseFloat(basicSalary) / 30;

        if (!startDate || !endDate || isNaN(dailyWage)) {
            alert('Please enter valid details for dates and basic salary.');
            return;
        }

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (end <= start) {
            alert('End date must be after the start date.');
            return;
        }

        const serviceYears = Math.floor((end - start) / (1000 * 60 * 60 * 24 * 365.25));

        let gratuityAmount = 0;

        if (serviceYears <= 5) {
            gratuityAmount = dailyWage * 21 * serviceYears;
        } else {
            const firstFiveYearsGratuity = dailyWage * 21 * 5;
            const additionalYears = serviceYears - 5;
            const additionalGratuity = dailyWage * 30 * additionalYears;
            gratuityAmount = firstFiveYearsGratuity + additionalGratuity;
        }

        // Ensure the gratuity does not exceed two years of basic salary
        const maxGratuity = parseFloat(basicSalary) * 24;
        if (gratuityAmount > maxGratuity) {
            gratuityAmount = maxGratuity;
        }

        setGratuity(gratuityAmount);
    };

    const formatNumber = (number) => {
        return number.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    };

    return (
        <div className={styles.container}>
            <div className={styles.inputGroup}>
                <label>First Day of Employment: </label>
                <TextInput
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    inputClassName={styles.input}
                />
            </div>
            <div className={styles.inputGroup}>
                <label>Last Day of Employment: </label>
                <TextInput
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    inputClassName={styles.input}
                />
            </div>
            <div className={styles.inputGroup}>
                <label>Basic Monthly Salary (AED): </label>
                <TextInput
                    type="number"
                    value={basicSalary}
                    onChange={(e) => setBasicSalary(e.target.value)}
                    placeholder="Enter your basic salary"
                    inputClassName={styles.input}
                />
            </div>
            <button
                onClick={calculateGratuity}
                className={styles.button}
            >
                Calculate Gratuity
            </button>
            {gratuity !== null && (
                <div className={styles.result}>
                    <strong>Calculated Gratuity: </strong>AED {formatNumber(gratuity)}
                </div>
            )}
        </div>
    );
};

export default GratuityCalculator;
